/**
 * Build a srcset for CMS image URLs that can be resized by their host.
 *
 * The seeded case-study and article photographs come from Pexels, which serves
 * any width from the same URL via a query parameter. Without a srcset the card
 * downloads one size for every layout: measured at 768px the homepage grid puts
 * those cards at 224 css and was still fetching 880px of image.
 *
 * Anything the client uploads themselves lands in Firebase Storage, which has no
 * resizing endpoint, so this returns undefined for those and the caller falls
 * back to a plain src. That is deliberate — inventing a srcset for URLs that
 * ignore the width parameter would make every entry fetch the same bytes while
 * telling the browser they differ.
 */

const RESIZABLE = /(^|\.)pexels\.com$/i;
const WIDTHS = [400, 600, 880, 1200];

function host(url) {
  try { return new URL(url).hostname; } catch { return ""; }
}

/** srcset string, or undefined when the host cannot resize. */
export function srcSetFor(url) {
  if (!url || !RESIZABLE.test(host(url))) return undefined;
  let base;
  try { base = new URL(url); } catch { return undefined; }
  return WIDTHS
    .map((w) => {
      const u = new URL(base);
      u.searchParams.set("w", String(w));
      // dpr multiplies w, so it has to go or every candidate is doubled.
      u.searchParams.delete("dpr");
      u.searchParams.delete("h");
      return `${u.toString()} ${w}w`;
    })
    .join(", ");
}
